var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('globe-menu',{on:{"click:menu-item":_vm.menuItemSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }